import React from 'react'

import NextBtn from './NextBtn'

import sections from '../data/sections'
import subSections from '../data/subSections'

const KeyComponentTitle = (props) => {
  const secId = props.match.params.secId
  const [ section ] = sections.filter((section) => secId === section.secId)
  const subSecId = props.match.params.subSecId
  const [ subSection ] = subSections.filter((subSection) => subSecId === subSection.subSecId)

  return (
    <div className="grid-container page">
        <div className="clear"></div>

        <div className="key-component-title">
            <div className={`icon ${secId}-icon`} dangerouslySetInnerHTML={section.icon}></div>
            <h3 className="bold question-title">{ `${section.number}. ${section.title}` }</h3>
            <h3>Next key component: { subSection.title }</h3>
            <NextBtn nextLabel="Continue" nextLink={`/question/${secId}/${subSecId}/${subSecId}1`} />
        </div>
    </div>
  )
}

export default KeyComponentTitle



// WEBPACK FOOTER //
// ./src/components/KeyComponentTitle.js